import { render, staticRenderFns } from "./86.vue?vue&type=template&id=1080cb28&scoped=true&"
var script = {}
import style0 from "./86.vue?vue&type=style&index=0&id=1080cb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080cb28",
  null
  
)

export default component.exports